import { render, staticRenderFns } from "./Produttore.vue?vue&type=template&id=4d6e9ef8&scoped=true"
import script from "./Produttore.vue?vue&type=script&lang=js"
export * from "./Produttore.vue?vue&type=script&lang=js"
import style0 from "./Produttore.vue?vue&type=style&index=0&id=4d6e9ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6e9ef8",
  null
  
)

export default component.exports